import React, {ReactElement} from 'react';
import {FormattedMessage} from 'react-intl';
import {Alignment, LinkProp} from '../../../types';
import sortByLabel from './sortByLabel';
import MultiColumns, {MultiColumnsVariant} from '../MultiColumns/MultiColumns';
import DynamicLink from '../../DynamicLink/DynamicLink';
import Headers, {HeaderType} from '../Text/Headers/Headers';

import './RelatedArticles.scss';

export enum RelatedArticlesBackgroundColor {
  WHITE = 'white',
}

interface Props {
  backgroundColor?: RelatedArticlesBackgroundColor;
  links: LinkProp[];
  className?: string;
}

function RelatedArticles({backgroundColor, links, className}: Props): ReactElement {
  const sortedLinks: LinkProp[] = sortByLabel(links);
  return (
    <div
      className={`relatedArticles ${backgroundColor ? `relatedArticles--${backgroundColor}` : ''} ${
        className || ''
      }`.trim()}
    >
      <Headers headerType={HeaderType.H4} alignment={Alignment.LEFT}>
        <FormattedMessage id="phoenix.relatedArticles.label" />
      </Headers>
      <MultiColumns<LinkProp>
        data={sortedLinks}
        variant={MultiColumnsVariant.TWO_COL_MAX}
        template={(link) => <DynamicLink href={link.href}>{link.label}</DynamicLink>}
      />
    </div>
  );
}

export default RelatedArticles;
